import * as React from 'react';
import { ThemeProvider } from 'styled-components';
import { StyleReset, StyleBase, NormalTheme } from '@longline/aqua-ui/styles';
import { ToastProvider } from '@longline/aqua-ui/services/Toast/ToastProvider';
import { ToastContainer } from '@longline/aqua-ui/services/Toast/ToastContainer';

import { Auth } from './contexts/auth/Auth';
import { Router } from './Router';
import { GlobalState } from './contexts/state/GlobalState';
import { Confirm } from './contexts/confirm/Confirm';

import 'mapbox-gl/dist/mapbox-gl.css';
import 'overlayscrollbars/overlayscrollbars.css';

const Main = () => {
  return (
    <ThemeProvider theme={NormalTheme}>
      <StyleReset/>
      <StyleBase/>
      <ToastProvider maxToasts={5}>
        <ToastContainer horizontalAlign='right' horizontalOffset={58} verticalOffset={76}/>
        <Auth>
          <GlobalState>
            <Confirm>
              <Router/>
            </Confirm>
          </GlobalState>
        </Auth>
      </ToastProvider>
    </ThemeProvider>
  );
}

export { Main }
